export default "/images/close-icon-black.png?28dc79555e1b545c3a2a33f79c99d6e3";